import "../enums/accordion.js";
import "../enums/alert.js";
import "../enums/avatar.js";
import "../enums/breakpoints.js";
import "../enums/button.js";
import "../enums/code-editor.js";
import { BrandfolderHexColors } from "../enums/colors.js";
import "../enums/combobox.js";
import "../enums/date.js";
import "../enums/drag-and-drop.js";
import "../enums/dialog.js";
import "../enums/divider.js";
import "../enums/dropdown.js";
import "../enums/fieldset.js";
import "../enums/font-icon.js";
import "../enums/fonts.js";
import "../enums/headings.js";
import "../enums/input.js";
import "../enums/keys.js";
import "../enums/list.js";
import "../enums/listbox.js";
import "../enums/loader.js";
import "../enums/margin.js";
import "../enums/option.js";
import "../enums/pill.js";
import "../enums/placements.js";
import "../enums/popout.js";
import "../enums/privacy.js";
import "../enums/radio-group.js";
import "../enums/status.js";
import "../enums/switch.js";
import "../enums/table.js";
import "../enums/tooltip.js";
import "../enums/transitions.js";
import "../enums/widths.js";
var defaultAlert = {
  backgroundColor: 'transparent',
  borderColor: 'transparent',
  iconColor: BrandfolderHexColors.Text,
  iconColorHover: BrandfolderHexColors.Title,
  textColor: BrandfolderHexColors.Text,
  textColorInline: BrandfolderHexColors.Text
};
var defaultAlertDark = {
  backgroundColor: 'transparent',
  borderColor: 'transparent',
  iconColor: BrandfolderHexColors.White,
  iconColorHover: BrandfolderHexColors.Gray,
  textColor: BrandfolderHexColors.White,
  textColorInline: BrandfolderHexColors.White
};
var errorAlert = {
  backgroundColor: '#FFE3E4',
  borderColor: '#FE999C',
  iconColor: BrandfolderHexColors.Delete,
  iconColorHover: '#9D0214',
  textColor: BrandfolderHexColors.Text,
  textColorInline: BrandfolderHexColors.Delete
};
var errorAlertDark = {
  backgroundColor: 'transparent',
  borderColor: '#FE999C',
  iconColor: BrandfolderHexColors.Delete,
  iconColorHover: '#9D0214',
  textColor: BrandfolderHexColors.White,
  textColorInline: BrandfolderHexColors.Delete
};
var successAlert = {
  backgroundColor: '#D3F9E7',
  borderColor: '#77EDB6',
  iconColor: '#00A042',
  iconColorHover: '#006D2D',
  textColor: BrandfolderHexColors.Text,
  textColorInline: '#00A042'
};
var successAlertDark = {
  backgroundColor: 'transparent',
  borderColor: '#77EDB6',
  iconColor: '#00A042',
  iconColorHover: '#006D2D',
  textColor: BrandfolderHexColors.White,
  textColorInline: '#00A042'
};
var warningAlert = {
  backgroundColor: '#FFF7DC',
  borderColor: '#FFE796',
  iconColor: '#D39F00',
  iconColorHover: '#A07900',
  textColor: BrandfolderHexColors.Text,
  textColorInline: '#D39F00'
};
var warningAlertDark = {
  backgroundColor: 'transparent',
  borderColor: '#FFE796',
  iconColor: '#D39F00',
  iconColorHover: '#A07900',
  textColor: BrandfolderHexColors.White,
  textColorInline: '#D39F00'
};
export { defaultAlert, defaultAlertDark, errorAlert, errorAlertDark, successAlert, successAlertDark, warningAlert, warningAlertDark };